import { render, staticRenderFns } from "./QuestionnaireDetailPage.vue?vue&type=template&id=8c3d2926&"
import script from "./QuestionnaireDetailPage.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports